import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { MemberLabsPage } from 'app/src/components/MemberLabsPage';

export const memberLabsPage = function () {
  return renderTopLevelComponent(<MemberLabsPage />);
};
